<template>
  <div class="sendChat">
    <div class="change-btn">
      <span
        class="btn-left"
        :class="{ active: active === 'title' }"
        @click="onTitle"
        >按标题展示</span
      >
      <span class="btn-center">
        <van-icon name="exchange" />
      </span>
      <span
        class="btn-right"
        :class="{ active: active === 'content' }"
        @click="onContent"
        >按内容展示</span
      >
    </div>
    <van-search
      v-model="searchVal"
      left-icon
      shape="round"
      input-align="center"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item of list" class="item" :key="item.id">
        <div class="title">
          <p class="van-ellipsis">{{ item.title }}</p>
          <p>
            <i
              v-if="item.type === '文本'"
              class="el-icon-document-copy"
              @click="copyText(item)"
            ></i>
            <van-button
              class="send-icon"
              :icon="xfeiji"
              type="default"
              @click="sendMessage(item)"
            ></van-button>
          </p>
        </div>
        <div
          v-show="showContent"
          class="content"
          :class="{ b: item.type === '文本' || item.type === '图片' }"
        >
          <div v-if="item.type === '文本'" class="c-item">
            <div class="c-item-desc">
              <div class="desc-text van-multi-ellipsis--l3">
                {{ item.describe }}
              </div>
            </div>
          </div>
          <div v-if="item.type === '图片'" class="c-item">
            <div class="c-item-desc">
              <van-image width="73" height="73" :src="item.url" />
            </div>
          </div>
          <div
            v-if="item.type === '文件' || item.type === '视频'"
            class="c-item"
          >
            <div class="c-item-desc">
              <p class="desc-file-name">{{ item.file_name }}</p>
              <van-icon name="description" size="40" />
            </div>
          </div>
          <div v-if="item.type === '链接'" class="c-item">
            <div class="c-item-title van-ellipsis">{{ item.link_title }}</div>
            <div class="c-item-desc">
              <div class="desc-text van-multi-ellipsis--l3">
                {{ item.describe }}
              </div>
              <div class="desc-img">
                <van-image width="44" height="44" :src="item.url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
// import VConsole from "vconsole";
import { wxConfig } from "@/mixins/weixin.js";
// let vconsole = new VConsole();
export default {
  name: "sendChat",
  mixins: [wxConfig],
  data() {
    return {
      xfeiji: require("@/assets/xfeiji.png"),
      list: [],
      loading: false,
      finished: false,
      page: 1,
      active: "content",
      searchVal: "",
      showContent: true,
    };
  },
  methods: {
    getData() {
      this.axios
        .post(
          "/crm/Assistant/getMaterial",
          qs.stringify({
            account_id: this.$route.query.account_id,
            phone: this.$route.query.phone,
            examineCode: this.$route.query.examineCode,
            page: this.page,
            title: this.title,
            content: this.content,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.list = this.list.concat(res.data.data.data);
            this.loading = false;
            if (this.list.length >= res.data.data.total) {
              this.finished = true;
            }
            this.page++;
          } else if (res.data.code == 0) {
            this.finished = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    onLoad() {
      this.getData();
    },
    onTitle() {
      this.active = "title";
      this.showContent = false;
    },
    onContent() {
      this.active = "content";
      this.showContent = true;
    },
    onSearch() {
      this.page = 1;
      this.list = [];
      switch (this.active) {
        case "title":
          this.content = "";
          this.title = this.searchVal;
          break;
        default:
          this.content = this.searchVal;
          this.title = "";
          break;
      }
      this.getData();
    },
    copyText(item) {
      const content = item.content;
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", `${content}`);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$toast("复制成功");
      }
      document.body.removeChild(input);
    },
    async sendMessage(item) {
      console.log("item", item);
      let type;
      if(item.type === "视频") {
        type = "video"
      } else if(item.type === "图片") {
        type = "image"
      } else {
        type = "file"
      }
      // let type = item.type === "视频" ? "video" : "file";
      let mediaid = item.media_id;
      if (item.type == "视频" || item.type == "文件" || item.type == "图片") {
        this.$toast.loading({
          message: "该素材过大，请稍等...",
          forbidClick: true,
          duration: 0,
        });
        const r = await this.axios.post(
          "/api/Alioss/upload_temp_file5",
          qs.stringify({
            account_id: this.$route.query.account_id,
            type,
            url: item.url2,
          }),
          {
            timeout: 60000,
          }
        );
        console.log("r", r);
        if (r.data.code == 1) {
          mediaid = r.data.data.media_id;
        }
        this.$toast.clear();
      }

      const that = this;
      this.$wx.invoke("getContext", {}, async function (res) {
        if (res.err_msg == "getContext:ok") {
          const entry = res.entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools
          if (entry == "single_chat_tools" || entry == "group_chat_tools") {
            switch (item.type) {
              case "文本":
                that.$wx.invoke(
                  "sendChatMessage",
                  {
                    msgtype: "text", //消息类型，必填
                    text: {
                      content: item.content, //文本内容
                    },
                  },
                  function (res) {
                    if (res.err_msg == "sendChatMessage:ok") {
                      //发送成功
                    } else {
                      that.$toast("发送失败");
                    }
                  }
                );
                break;
              case "图片":
                that.$wx.invoke(
                  "sendChatMessage",
                  {
                    msgtype: "image", //消息类型，必填
                    image: {
                      mediaid, //图片的素材id
                    },
                  },
                  function (res) {
                    if (res.err_msg == "sendChatMessage:ok") {
                      //发送成功
                    } else {
                      that.$toast("发送失败");
                    }
                  }
                );
                break;
              case "视频":
                console.log("视频");
                that.$wx.invoke(
                  "sendChatMessage",
                  {
                    msgtype: "video", //消息类型，必填
                    video: {
                      mediaid, //素材id
                    },
                  },
                  function (res) {
                    if (res.err_msg == "sendChatMessage:ok") {
                      //发送成功
                    } else {
                      that.$toast("发送失败");
                    }
                  }
                );
                break;
              case "文件":
                console.log("文件");
                that.$wx.invoke(
                  "sendChatMessage",
                  {
                    msgtype: "file", //消息类型，必填
                    file: {
                      mediaid, //素材id
                    },
                  },
                  function (res) {
                    if (res.err_msg == "sendChatMessage:ok") {
                      //发送成功
                    } else {
                      that.$toast("发送失败");
                    }
                  }
                );

                break;
              case "链接":
                that.$wx.invoke(
                  "sendChatMessage",
                  {
                    msgtype: "news", //消息类型，必填
                    news: {
                      link: item.link_url, //H5消息页面url 必填
                      title: item.link_title, //H5消息标题
                      desc: item.describe, //H5消息摘要
                      imgUrl: item.url, //H5消息封面图片URL
                    },
                  },
                  function (res) {
                    if (res.err_msg == "sendChatMessage:ok") {
                      //发送成功
                    } else {
                      that.$toast("发送失败");
                    }
                  }
                );
                break;
              default:
                break;
            }
          }
        } else {
          //错误处理
        }
      });
    },
  },
};
</script>
<style scoped>
.van-search .van-cell {
  margin-top: 6px;
  padding: 6px 16px;
}
.sendChat {
  color: #333;
}
.change-btn {
  padding-top: 2.0rem;
  display: flex;
  justify-content: center;
  font-size: 13px;
}
.btn-center {
  margin: 0 2.0rem;
}
.change-btn .active {
  color: #3375e8;
}
.van-list {
  padding: 1.0rem 12px;
}
.item {
  margin: 1.0rem 0;
}
.item .title {
  padding: 1.0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgb(234, 234, 234);
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.content {
  border: 1px solid rgb(234, 234, 234);
  border-top: 0;
  padding: 1.0rem;
  line-height: 1.425;
  color: #666;
  font-size: 14px;
}

.c-item {
  border: 1px solid #eaeaea;
  padding: 15px;
  border-radius: 3px;
  max-width: 24.0rem;
}
.c-item .c-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #666;
}
.c-item .c-item-desc {
  margin-top: .8rem;
  display: flex;
}
.desc-file-name {
  flex: 1;
  max-width: 24.0rem;
  word-break: break-all;
}
.c-item-desc .desc-text {
  color: 999;
  flex: 1;
}

.content.b .c-item {
  border: none;
  max-width: 100%;
  padding: .0rem;
}
.content.b .c-item .c-item-desc {
  margin-top: 0;
}

.van-button--default {
  height: auto;
  line-height: 1;
  padding: 6px .8rem;
  border: none;
}

.el-icon-document-copy {
  padding: 6px .8rem;
}
</style>